export default "__VITE_ASSET__2GqwHnlw__"